import axios from 'axios';
import { toast } from 'react-toastify';
import { getAuthToken, removeAuthToken } from './utils/auth-token';

const instance = axios.create({ baseURL: import.meta.env.VITE_BASE_URL });

instance.interceptors.request.use((config) => {
  const token = getAuthToken();
  config.headers['Authorization'] = `Bearer ${token}`;
  config.headers['Access-Control-Allow-Credentials'] = 'true';
  config.headers['Access-Control-Allow-Origin'] = '*';
  // Only set Accept-Language if not already set in the request config
  if (!config.headers['Accept-Language']) {
    config.headers['Accept-Language'] = localStorage.getItem('lang') || 'ar';
  }
  config.headers['Active-Tenant-Id'] =
    localStorage.getItem('active_tenant_id') || '';
  return config;
});

//error handling to axios instance and show error message with toast for every poosible error
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    switch (error?.response?.status) {
      case 400:
        toast.error(error.response.data.message);
        break;
      case 401:
        toast.error(error.response.data.message);
        
        // Don't redirect if we're on invitation route
        const isInvitationRoute = window.location.pathname.includes('/i/');
        if (!isInvitationRoute) {
          window.location.href = '/login';
          removeAuthToken();
          localStorage.removeItem('email');
        }
        break;
      case 403:
        toast.error(error.response.data.message);
        
        // Don't redirect if we're on invitation route
        const isInvitationRoute403 = window.location.pathname.includes('/i/');
        if (!isInvitationRoute403) {
          const token = getAuthToken();
          if (token && token !== 'undefined') {
            setTimeout(() => {
              if (!window.location.href.includes('/appointments')) {
                window.location.href = '/appointments';
              }
            }, 1000);
          } else {
            setTimeout(() => {
              window.location.href = '/login';
            }, 1000);
          }
        }
        break;
      case 404:
        toast.error(error.response.data.message);
        window.location.href = '/404';
        break;
      case 500:
        toast.error('something went wrong');
        window.location.href = '/error';
        break;
      case 422:
        break;
      default:
        toast.error(error?.response?.data?.message);
        break;
    }
    return Promise.reject(error);
  }
);

export default instance;
